export function Spinner({ label = 'Loading…' }: { label?: string }) {
  return (
    <span class="spinner" role="status" aria-live="polite">
      <span class="spinner-dot" /> {label}
    </span>
  );
}
